//On DOM Load
jQuery(document).ready(function($) {

    $('#main-nav .menu').slicknav({
        label: '',
        allowParentLinks: true,
        init: function(){
            $('.slicknav_nav').width($(window).width());
            $('.slicknav_nav').height($(window).height());
            $('.slicknav_btn').addClass('animateSlickBurger');

            // Move the slicknav menu to .navContainer
            $('.slicknav_menu').appendTo('.navContainer');
        }
    });

    $('.serviceSlider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        prevArrow: '<i class="fa-solid fa-arrow-left"></i>',
        nextArrow: '<i class="fa-solid fa-arrow-right"></i>',
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
    });

    $('.projectSlider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: false,
        arrows: true,
        prevArrow: '<i class="fa-solid fa-arrow-left"></i>',
        nextArrow: '<i class="fa-solid fa-arrow-right"></i>',
        responsive: [
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 500, settings: { slidesToShow: 1 } }
        ]
    });

    $('.singleProject .galleryThumbnails').slick({
        vertical: true,
        // adaptiveHeight: true,
        rows: 1, // Two rows of images per slide
        slidesPerRow: 2, // One image per row
        slidesToShow: 3, // Two rows * One image per row = 2 images visible
        slidesToScroll: 1, // Scrolls two images at a time
        verticalSwiping: true,
        infinite: false,
        arrows: true,
        prevArrow: '<i class="fa-solid fa-arrow-up"></i>',
        nextArrow: '<i class="fa-solid fa-arrow-down"></i>',
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    rows: 1, // Only one row on mobile
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.testimonials.slider').slick({
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        fade: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        prevArrow: '<i class="fa-solid fa-arrow-left"></i>',
        nextArrow: '<i class="fa-solid fa-arrow-right"></i>',
        // responsive: [
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             arrows: false,
        //             centerMode: true,
        //             centerPadding: '40px',
        //             slidesToShow: 1
        //             }
        //         },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //         arrows: false,
        //             centerMode: true,
        //             centerPadding: '40px',
        //             slidesToShow: 1
        //         }
        //     }
        // ]
    });

    $(window).on('resize scroll', function(){
        $('.slicknav_nav').width($(window).width());
        $('.slicknav_nav').height($(window).height());
    });
});